export interface MediaSpendEntry {
  id: string;
  date: string;
  amount: number;
  campaignName: string;
  notes: string;
}

export interface MediaPauseEntry {
  id: string;
  startDate: string;
  endDate: string;
  resumeDate: string;
  reason: string;
  status: 'planned' | 'done';
}

export interface MediaBuyingAccount {
  id: string;
  clientName: string;
  clientEmail: string;
  subscriptionId: string;
  subscriptionNumber: string;
  serviceName: string;
  channel: string;
  monthlyRevenue: number;
  budgetTarget: number;
  currencyCode: string;
  googleAdsCustomerId: string;
  spends: MediaSpendEntry[];
  pauses: MediaPauseEntry[];
  updatedAt: string;
  campaigns?: Array<{
    campaignId: string;
    campaignName: string;
    campaignStatus: string;
    cost: number;
    clicks: number;
    impressions: number;
  }>;
  lastGoogleSyncAt?: string;
}

const ENDPOINT = '/api/admin/media-buying';

const parseResponse = async <T,>(response: Response): Promise<T> => {
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(payload?.error || payload?.message || 'Erreur media buying');
  }
  return payload as T;
};

export const adminMediaBuyingService = {
  async getAccounts(): Promise<MediaBuyingAccount[]> {
    const response = await fetch(ENDPOINT, { credentials: 'include', cache: 'no-store' });
    const payload = await parseResponse<{ accounts?: MediaBuyingAccount[] }>(response);
    return Array.isArray(payload.accounts) ? payload.accounts : [];
  },
  async saveAccounts(accounts: MediaBuyingAccount[]): Promise<MediaBuyingAccount[]> {
    const response = await fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ accounts }),
    });
    const payload = await parseResponse<{ accounts?: MediaBuyingAccount[] }>(response);
    return Array.isArray(payload.accounts) ? payload.accounts : [];
  },
};
